var availabilityCache = {};
var availabilitySessions = [];
const availableDates = window.$myAvailableDates instanceof Set ? window.$myAvailableDates : new Set(window.$myAvailableDates || []);
window.$myAvailableDates = availableDates;

var slideInstantBookSession = window.slideInstantBookSession || function() {};

var calendarStartDate = new Date();
var calendarEndDate = null;

function updateDatepickerFromSet(viewDate, options) {
    // Disabled to prevent calendar snap-back issues
    // This function was causing the calendar to jump back to the first month
    return;
}

function debounce(fn, wait) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            fn.apply(context, args);
        }, wait);
    };
}

$(function () {
    if (!ibp) {
        return;
    }

    if (window.crawlerbot) {
        $(".instantBook").hide();
        return;
    }

    var now = Date.now();
    if (!window.loadAvailabilityPromise || !window.loadAvailabilityPromiseExpiry || now > window.loadAvailabilityPromiseExpiry) {
        window.loadAvailabilityPromise = loadAvailability();
        var expiry = now + 5 * 60 * 1000; // 5 minutes
        window.loadAvailabilityPromiseExpiry = expiry;
        setTimeout(function() {
            if (window.loadAvailabilityPromiseExpiry === expiry) {
                window.loadAvailabilityPromise = null;
                window.loadAvailabilityPromiseExpiry = 0;
            }
        }, 5 * 60 * 1000);
    }

    window.loadAvailabilityPromise.then(function() {
        if (availableDates.size === 0) {
            $(".instantBook").hide();
            return;
        }

        var lookAhead = parseInt(aml, 10) || 6;
        calendarStartDate = new Date();
        // Don't set a restrictive end date - allow unlimited navigation
        calendarEndDate = new Date(calendarStartDate.getFullYear() + 2, 11, 31); // 2+ years ahead

        // Bootstrap Datepicker treats Date options as UTC when it renders them.
        // Passing local midnight on the first of a month can therefore display
        // the previous month in positive UTC offsets (for example, Sydney).
        var initialViewDate = {
            year: calendarStartDate.getFullYear(),
            month: calendarStartDate.getMonth(),
            day: 1
        };

        // Find the first month with available dates to set as initial view.
        // Use the datepicker's timezone-neutral object format rather than Date.
        if (availableDates.size > 0) {
            var sortedDates = Array.from(availableDates).sort();
            if (sortedDates.length > 0) {
                var firstAvailableDateParts = sortedDates[0].split('-');
                if (firstAvailableDateParts.length === 3) {
                    initialViewDate = {
                        year: parseInt(firstAvailableDateParts[0], 10),
                        month: parseInt(firstAvailableDateParts[1], 10) - 1,
                        day: 1
                    };
                }
            }
        }

        $("#calendar1").datepicker({
            format: {
                toDisplay: function(date, format, language) {
                    var d = new Date(date);
                    d.setDate(d.getDate());
                    return d.toDateString();
                },
                toValue: function(date, format, language) {
                    var d = new Date(date);
                    d.setDate(d.getDate());
                    return new Date(d);
                }
            },
            beforeShowDay: function(date) {
                return { enabled: availableDates.has(convertToYMDDashDate(date)) };
            },
            startDate: calendarStartDate,
            endDate: calendarEndDate,
            todayHighlight: false,
            autoclose: true,
            defaultViewDate: initialViewDate
        });

        // Add CSS to hide dates from other months
        var hideOtherMonthsCSS = `
            .datepicker .datepicker-days .table-condensed tbody tr td.old,
            .datepicker .datepicker-days .table-condensed tbody tr td.new {
                visibility: hidden;
            }
        `;
        if (!document.getElementById('hide-other-months-styles')) {
            var style = document.createElement('style');
            style.id = 'hide-other-months-styles';
            style.innerHTML = hideOtherMonthsCSS;
            document.head.appendChild(style);
        }

        var handleMonthChange = function(e) {
            var yr = e.date.getFullYear();
            var mth = e.date.getMonth();

            // Calculate the allowed month range (current month - 1 to current month + 15)
            var now = new Date();
            var minAllowedMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            var maxAllowedMonth = new Date(now.getFullYear(), now.getMonth() + 15, 1);

            // Fetch availability for this month and next 2 months if not cached
            for (var i = 0; i < 3; i++) {
                var targetMonth = new Date(yr, mth + i, 1);
                var targetMonthEnd = new Date(yr, mth + i + 1, 0);

                // Skip if the target month is outside the allowed range
                if (targetMonth < minAllowedMonth || targetMonth >= maxAllowedMonth) {
                    continue;
                }

                var from = convertToYMDDashDate(targetMonth);
                var to = convertToYMDDashDate(targetMonthEnd);
                var cacheKey = from + '_' + to;
                
                if (!availabilityCache[cacheKey]) {
                    fetchAvailability(from, to).then(function(data) {
                        if (data && Array.isArray(data.sessions)) {
                            var existing = {};
                            availabilitySessions.forEach(function(s) { existing[s.id] = true; });
                            data.sessions.forEach(function(s) {
                                if (!existing[s.id]) { availabilitySessions.push(s); }
                            });
                            var newDates = parseSessionsToDates(data.sessions);
                            newDates.forEach(function(d) { availableDates.add(d); });
                            
                            // Don't call datepicker('update') as it causes snap-back to first available month
                            // The beforeShowDay function will automatically use the updated availableDates
                        }
                    });
                }
            }
        };

        $("#calendar1").on('changeMonth', handleMonthChange);

        $("#calendar1").on('changeDate', function(e) {
            var n = convertToYMDDashDate(e.date);
            $("#bookDate").val(n);
            instantBookv2(n);
        });

        // Only set initial dates, don't call updateDatepickerFromSet after setup
        $("#bookForm").removeClass('hidden');
    });
});


    function convertToYMDDashDate(date) {
        var theDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
        return theDate;
    }

    function parseSessionsToDates(sessions) {
        if (!Array.isArray(sessions)) return [];
        var dates = [];
        sessions.forEach(function(sess) {
            if (typeof sess.seatsAvailable === 'number' && sess.seatsAvailable > 0) {
                var datePart = (sess.startTimeLocal || '').substring(0, 10);
                if (datePart) {
                    dates.push(datePart);
                }
            }
        });
        return Array.from(new Set(dates));
    }

    function ensureAvailabilitySession() {
        var requiresBootstrap = Boolean(window.productSessionDeferred && !window.csrfToken);

        if (!requiresBootstrap) {
            return Promise.resolve(false);
        }

        if (typeof window.ensureThrillSession !== 'function') {
            return Promise.reject(new Error('Session bootstrap is unavailable.'));
        }

        // ensureThrillSession deduplicates concurrent callers. This matters because
        // the initial calendar load requests several months at the same time.
        return Promise.resolve(window.ensureThrillSession()).then(function(token) {
            if (!window.csrfToken && token) {
                window.csrfToken = token;
            }
            if (!window.csrfToken) {
                throw new Error('Session bootstrap did not return a CSRF token.');
            }
            return true;
        });
    }

    function fetchAvailability(fromDateStr, toDateStr) {
        var cacheKey = fromDateStr + '_' + toDateStr;
        var cached = availabilityCache[cacheKey];
        if (cached) {
            return cached;
        }

        if (window.crawlerbot) {
            return Promise.resolve({ sessions: [] });
        }

        var rawProductRef = typeof window !== 'undefined' ? window.theRef : undefined;
        var productRef = typeof rawProductRef === 'string' ? rawProductRef.trim() : rawProductRef;
        if (!productRef) {
            console.warn('Skipping availability request: missing productRef.');
            return Promise.resolve(null);
        }

        var params = new URLSearchParams({
            productRef: productRef,
            threshold: '30',
            source: src,
            fromDate: fromDateStr,
            toDate: toDateStr
        });
        if (typeof window.pID !== 'undefined' && window.pID !== null && window.pID !== '') {
            params.set('productID', window.pID.toString());
        }
        var promise = ensureAvailabilitySession().then(function(sessionWasBootstrapped) {
            // A newly bootstrapped session is already fresh. Existing sessions keep
            // their previous sliding-expiration behaviour.
            if (!sessionWasBootstrapped) {
                slideInstantBookSession();
            }

            return fetch('/inc/api/getavailability.aspx?' + params.toString(), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': window.csrfToken || ''
                }
            });
        }).then(function(resp) {
            if (!resp.ok) throw new Error('Network');
            return resp.json();
        }).then(function(json) {
            availabilityCache[cacheKey] = Promise.resolve(json);
            return json;
        }).catch(function(err) {
            delete availabilityCache[cacheKey];
            return null;
        });

        availabilityCache[cacheKey] = promise;
        return promise;
    }

    function loadAvailability() {
        if (window.crawlerbot) {
            return Promise.resolve([]);
        }

        var now = new Date();

        $(".waitIco").addClass("is-loading");

        var monthsToFetch = parseInt(aml, 10);
        if (isNaN(monthsToFetch) || monthsToFetch < 1) {
            monthsToFetch = 6;
        }
        var requests = [];
        for (var i = 0; i < monthsToFetch; i++) {
            var start = new Date(now.getFullYear(), now.getMonth() + i, 1);
            var end = new Date(now.getFullYear(), now.getMonth() + i + 1, 0);
            var fromStr = convertToYMDDashDate(start);
            var toStr = convertToYMDDashDate(end);
            requests.push(fetchAvailability(fromStr, toStr));
        }

        return Promise.all(requests).then(function(results) {
            availabilitySessions = [];
            availableDates.clear();
            var found = false;
            results.forEach(function(data) {
                if (!data || !Array.isArray(data.sessions) || data.sessions.length === 0) {
                    return;
                }
                if (!found) {
                    found = true;
                }
                availabilitySessions = availabilitySessions.concat(data.sessions);
                parseSessionsToDates(data.sessions).forEach(function(d) { availableDates.add(d); });
            });

            if (!found && monthsToFetch < 6) {
                var extraRequests = [];
                for (var j = monthsToFetch; j < 6; j++) {
                    var startExtra = new Date(now.getFullYear(), now.getMonth() + j, 1);
                    var endExtra = new Date(now.getFullYear(), now.getMonth() + j + 1, 0);
                    var fromStrExtra = convertToYMDDashDate(startExtra);
                    var toStrExtra = convertToYMDDashDate(endExtra);
                    extraRequests.push(fetchAvailability(fromStrExtra, toStrExtra));
                }
                return Promise.all(extraRequests).then(function(extraResults) {
                    extraResults.forEach(function(data) {
                        if (!data || !Array.isArray(data.sessions) || data.sessions.length === 0) {
                            return;
                        }
                        availabilitySessions = availabilitySessions.concat(data.sessions);
                        parseSessionsToDates(data.sessions).forEach(function(d) { availableDates.add(d); });
                    });
                    return availabilitySessions;
                });
            }
            // Don't call updateDatepickerFromSet here as it causes snap-back
        }).finally(function() {
            $(".waitIco").removeClass("is-loading");
        });
    }



function ensureSwiperLoaded() {
    return new Promise(function(resolve, reject) {
        if (typeof window !== 'undefined' && typeof window.Swiper !== 'undefined') {
            return resolve(window.Swiper);
        }

        var existingScript = document.querySelector('script[data-swiper-loader="true"]') ||
            document.querySelector('script[src*="swiper@11.2.6/swiper-bundle.min.js"]');

        if (existingScript) {
            var onExistingLoad = function() {
                existingScript.setAttribute('data-swiper-loaded', 'true');
                existingScript.removeEventListener('load', onExistingLoad);
                existingScript.removeEventListener('error', onExistingError);
                resolve(window.Swiper);
            };
            var onExistingError = function() {
                existingScript.removeEventListener('load', onExistingLoad);
                existingScript.removeEventListener('error', onExistingError);
                reject(new Error('Failed to load Swiper library'));
            };
            if (existingScript.getAttribute('data-swiper-loaded') === 'true' && typeof window.Swiper !== 'undefined') {
                return resolve(window.Swiper);
            }
            existingScript.addEventListener('load', onExistingLoad);
            existingScript.addEventListener('error', onExistingError);
            return;
        }

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.2.6/swiper-bundle.min.js';
        script.setAttribute('data-swiper-loader', 'true');
        var onScriptLoad = function() {
            script.setAttribute('data-swiper-loaded', 'true');
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
            resolve(window.Swiper);
        };
        var onScriptError = function() {
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
            reject(new Error('Failed to load Swiper library'));
        };
        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        (document.head || document.body).appendChild(script);
    });
}

$(function () {

    if ($(window).width() <= 767) {  // Mobile device check
        $.ajax({
            type: 'GET',
            url: '/inc/ajax/displayproductimages',
            data: {
                                        p: + pID,
                                        showAll: 0
                        },
            dataType: 'json',
            success: function(response) {
                var swiperContainer = $('.swiper-wrapper');
                try {
                    var itemsArray = Object.values(response);
                                        $.each(itemsArray, function(index, item) {
                                                swiperContainer.append('<div class="swiper-slide"><img src="https://content.thrillexperiences.com.au/content/product-img/362w/' + item + '" loading="lazy"><div class="swiper-lazy-preloader"></div></div>');
                                        });
                    // Initialize
                    ensureSwiperLoaded().then(function() {
                        new Swiper('.swiper-container', {
                                                direction: 'horizontal',
                                                loop: true,
                                                pagination: {
                                                        el: '.swiper-pagination',
                                                },
                                                on: {
                                                        sliderMove: function() {
                                                                $('span.sale').fadeOut();
                                                        },
                                                        touchEnd: function() {
                                                                        $('span.sale').fadeIn();
                                                        },
                                                        slideChangeTransitionEnd: function() {
                                                                $('span.sale').fadeIn();
                                                        }
                                                }
                                        });
                    }).catch(function() {
                        // Swiper failed to load; leave fallback static image in place
                    });
                } catch (e) {
                    //console.error("Error loading images: ", e);
                }
            }
        });
    }
});

$(function() {
	$('#myModal').on('show.bs.modal', function() {
		$.ajax({
			type: 'GET',
			url: '/inc/ajax/displayproductimages',
			data: {
					p: + pID,
					showAll: 0  
			},
			dataType: 'json',
			success: function(response) {
				var modalBody = $('#myModal .modal-body');
				modalBody.empty();

				 // For PCs
					try { 
						var itemsArray = Object.values(response);
						$.each(itemsArray, function(index, item) {
							modalBody.append('<img src="https://content.thrillexperiences.com.au/content/product-img/724w/' + item + '"><br><br>');
						});
					} catch (e) {
						modalBody.append('<p>' + response + '</p>');
					}
			}
		});
	});
});

var $mobVoucher = $(".mob-buyvoucher");
var $placeholder = $(".sticky-parent");
var initialMobVoucherTop = $mobVoucher.length ? $mobVoucher.offset().top : null;  // Capture the initial top position when available

if (initialMobVoucherTop !== null) {
    $(document).scroll(function () {
        var scrollPosition = $(window).scrollTop();

        // Add 'sticky' class when the scroll position is greater than or equal to the initial top position of .mob-buyvoucher
        if (scrollPosition >= initialMobVoucherTop) {
            $mobVoucher.addClass('sticky');
            $placeholder.addClass("stickyOffsetMargin");
        } else {
            // Remove 'sticky' class when scrolling back up past the initial position
            $mobVoucher.removeClass('sticky');
            $placeholder.removeClass("stickyOffsetMargin");
        }
    });
}

$(document).ready(function() {
    $.ajax({
        url: '/inc/ajax/getproductnotifications',
        type: 'GET',
        data: {
            p: pID,
            pp: ap,
            s: sid,
            m: aml
        },
        dataType: 'json',
        success: function(data) {
            var notificationBox = $('#notification-box');
            notificationBox.empty();

            if (data.length === 0) {
                notificationBox.hide();
            } else {
                notificationBox.show();
                $.each(data, function(index, item) {
                    var notificationItem = '<div class="notification-item' + (index === 0 ? ' active' : '') + '">' + item.isPopular + '</div>';
                    notificationBox.append(notificationItem);
                });

                var items = $('.notification-item');
                var currentIndex = 0;
                setInterval(function() {
                    items.eq(currentIndex).removeClass('active');
                    currentIndex = (currentIndex + 1) % items.length;
                    items.eq(currentIndex).addClass('active');
                }, 3000);
            }
        },
        error: function() {
            console.error('Failed to fetch notifications.');
            $('#notification-box').hide(); 
        }
    });
});
